export default "__VITE_ASSET__BeBVZ7G4__"